import { TaxonomyCellRenderer } from "../ViewMasterCampaigns/utils";
import { TD_TYPE } from "@acadia-ui/datatable";

export const ERROR_BANNER_TIMEOUT = 5000;

export const TABS = [
	{
		label: "Campaigns",
		panelId: "campaigns-activity-table",
		disabled: false
	},
	{
		label: "Taxonomy",
		panelId: "taxonomy-activity-table",
		disabled: false
	}
];

export const TAXONOMY_COLUMNS = [
	{
		label: "Taxonomy",
		bind: "TaxonomyString",
		isSortable: true,
		type: TD_TYPE.NONE,
		onRender: (value) => <TaxonomyCellRenderer taxonomy={value} />
	},
	{
		label: "Configuration Name",
		bind: "TaxonomyConfigurationName",
		isSortable: true,
		type: TD_TYPE.TEXT
	},
	{
		label: "Platform",
		bind: "MasterPlatformName",
		isSortable: true,
		type: TD_TYPE.TEXT
	},
	{
		label: "",
		bind: "TaxonomyOrigin",
		isSortable: true,
		type: TD_TYPE.TEXT
	},
	{
		label: "Created By",
		bind: "createdByUserName",
		isSortable: true,
		type: TD_TYPE.TEXT
	},
	{
		label: "Created",
		bind: "formattedCreatedDate",
		isSortable: true,
		type: TD_TYPE.DATE
	},
	{
		label: "Modified By",
		bind: "updatedByUserName",
		isSortable: true,
		type: TD_TYPE.TEXT
	},
	{
		label: "Last Modified",
		bind: "formattedLastModifiedDate",
		isSortable: true,
		type: TD_TYPE.DATE
	}
];

export const CAMPAIGN_COLUMNS = [
	{
		label: "Taxonomy",
		bind: "TaxonomyString",
		isSortable: true,
		type: TD_TYPE.NONE,
		onRender: (value) => <TaxonomyCellRenderer taxonomy={value} />
	},
	{
		label: "Campaign Name",
		bind: "CampaignName_Friendly",
		isSortable: true,
		type: TD_TYPE.TEXT
	},
	{
		label: "Platform",
		bind: "MasterPlatformName",
		isSortable: true,
		type: TD_TYPE.TEXT
	},
	{
		label: "Country",
		bind: "MasterCountryName",
		isSortable: true,
		type: TD_TYPE.TEXT
	},
	{
		label: "Created By",
		bind: "createdByUserName",
		isSortable: true,
		type: TD_TYPE.TEXT
	},
	{
		label: "Created",
		bind: "formattedCreatedDate",
		isSortable: true,
		type: TD_TYPE.DATE
	},
	{
		label: "Modified By",
		bind: "updatedByUserName",
		isSortable: true,
		type: TD_TYPE.TEXT
	},
	{
		label: "Last Modified",
		bind: "formattedLastModifiedDate",
		isSortable: true,
		type: TD_TYPE.DATE
	}
];
